var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShieldPersonFill = function SvgShieldPersonFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13q1.45 0 2.475-1.025A3.37 3.37 0 0 0 15.5 9.5q0-1.45-1.025-2.475A3.37 3.37 0 0 0 12 6q-1.45 0-2.475 1.025A3.37 3.37 0 0 0 8.5 9.5q0 1.45 1.025 2.475A3.37 3.37 0 0 0 12 13m0 6.9a7.2 7.2 0 0 0 2.613-1.487 11.9 11.9 0 0 0 1.987-2.288 10.4 10.4 0 0 0-2.238-.838A9.8 9.8 0 0 0 12 15q-1.2 0-2.363.287-1.161.288-2.237.838.851 1.275 1.987 2.288A7.2 7.2 0 0 0 12 19.9m0 2a2 2 0 0 1-.625-.1Q8 20.676 6 17.637 4 14.6 4 11.1V6.375q0-.626.362-1.125.363-.5.938-.725l6-2.25a2.1 2.1 0 0 1 .7-.125q.35 0 .7.125l6 2.25q.575.225.938.725.362.5.362 1.125V11.1q0 3.5-2 6.538-2 3.037-5.375 4.162-.15.05-.3.075T12 21.9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShieldPersonFill);
export { ForwardRef as ReactComponent };